import React from 'react';
import PropTypes from 'prop-types';

const SearchView = ({ 
  placeholder = "Search...", 
  leftIcon, 
  rightIcon, 
  value, 
  onChange, 
  className = "",
  ...props 
}) => {
  return (
    <div className={`relative flex items-center ${className}`}>
      {leftIcon && (
        <img 
          src="assets/images/u_search.svg"
          className="absolute left-3 sm:left-4 lg:left-[12px] w-4 h-4 sm:w-5 sm:h-5 lg:w-[20px] lg:h-[20px] z-10" 
          alt="" 
        />
      )}
      
      <input
        type="text"
        placeholder={placeholder}
        value={value}
        onChange={onChange}
        className={`
          w-full 
          bg-global-4 
          text-global-7 
          text-xs sm:text-sm lg:text-[14px] 
          font-svn-gilroy 
          font-medium 
          leading-[15px] 
          rounded-[22px] 
          py-2 sm:py-2.5 lg:py-3 
          ${leftIcon ? 'pl-8 sm:pl-10 lg:pl-12' : 'pl-4 sm:pl-6 lg:pl-7'} 
          ${rightIcon ? 'pr-8 sm:pr-10 lg:pr-12' : 'pr-4 sm:pr-6 lg:pr-7'}
          focus:outline-none 
          focus:ring-2 
          focus:ring-global-text4 
          focus:border-transparent
          transition-all 
          duration-200
        `}
        {...props}
      />
      
      {rightIcon && (
        <img 
          src={rightIcon} 
          className="absolute right-3 sm:right-4 lg:right-[12px] w-4 h-4 sm:w-5 sm:h-5 lg:w-[20px] lg:h-[20px] z-10" 
          alt="Right icon" 
        />
      )}
    </div>
  );
};

SearchView.propTypes = {
  placeholder: PropTypes?.string,
  leftIcon: PropTypes?.string,
  rightIcon: PropTypes?.string,
  value: PropTypes?.string,
  onChange: PropTypes?.func,
  className: PropTypes?.string,
};

export default SearchView;